import React, { useLayoutEffect, useRef, useState } from 'react';
import MaskLoading from '@/components/mask-loading';

const ColsContainer: React.FC<{
    children?: React.ReactNode;
    cols: number;
    onResize?: (width: number, height: number) => void;
}> = ({ cols, onResize, children }) => {
    const divRef = useRef<HTMLDivElement>(null);
    const onResizeRef = useRef(onResize);
    const [size, setSize] = useState({ width: 0, height: 0 });

    onResizeRef.current = onResize;

    useLayoutEffect(() => {
        const el = divRef.current;
        if (!el) return;

        const syncSize = (width: number, height: number) => {
            setSize((prev) => (prev.width === width && prev.height === height ? prev : { width, height }));
            onResizeRef.current?.(width, height);
        };

        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                syncSize(width, height);
            }
        });

        resizeObserver.observe(el);

        // React 18 createRoot 下仅依赖 ResizeObserver 异步回调时，可能一直停在初始 0×0
        const { width, height } = el.getBoundingClientRect();
        syncSize(width, height);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    // 无插件层内容时不挂 MaskLoading，避免与 editor-container 内 mask-loading 插件叠出两个 loading
    const hasOverlayContent = React.Children.toArray(children).some(React.isValidElement);

    return (
        <div className={`p-editor__cols${cols}`} ref={divRef}>
            <div className="p-editor__cols-container" style={{ width: size.width, height: size.height }}>
                {children}
            </div>
            {hasOverlayContent ? <MaskLoading /> : null}
        </div>
    );
};

export default ColsContainer;
